module.exports = __webpack_public_path__ + "img/new_contact.90d11631.svg";